import React from 'react';
import { ControlledDialog } from './ControlledDialog';
import { CTAButton, CustomerSupportLink } from '../../buttons';
import { useTranslation } from 'react-i18next';

type NoMatchingTablesProps = {
	open: boolean;
	onDismiss: () => void;
};

export const NoMatchingTables = ({ open, onDismiss }: NoMatchingTablesProps) => {
	const { t } = useTranslation();
	const body = (
		<>
			<p>{t('dialogs.no_matching_tables_body_1')}</p>
			<p>{t('dialogs.no_matching_tables_body_2', { supportLink: <CustomerSupportLink /> })}</p>
		</>
	);

	return (
		<ControlledDialog
			isOpen={open}
			hasCloseButton={false}
			onClose={() => { }}
			icon='error'
			title={t('dialogs.no_matching_tables_title')}
			body={body}
			footer={
				<>
					<CTAButton buttonText={t('actions.dismiss')} onClick={onDismiss} variant='dark' />
				</>
			}
		/>
	);
};
